export abstract class ShareBaseDialog {
    constructor(
        private $mdDialog,
        private template:string,
        public title:string,
        private fullScreen:boolean = false,
        private clickOutsideToClose:boolean = false
    ){
    }

    public open(event?:ng.IAngularEvent, ...args:any[]):ng.IPromise<any>{
        return this.$mdDialog.show({
            controller: () => this,
            controllerAs: 'vm',
            targetEvent: event,
            template: this.template,
            fullscreen: this.fullScreen,
            clickOutsideToClose: this.clickOutsideToClose,
            onComplete: (scope, element) => {
                scope.$on('$destroy', () => {
                    let body = document.querySelector('body');
                    let searchScrollMask = document.querySelector('body .md-scroll-mask');
                    if (searchScrollMask) {
                        body.removeChild(searchScrollMask);
                    }
                });
            }
            
        });
    }
    public dismiss(retVal?):void {
        this.$mdDialog.hide(retVal);
    }

    public cancel() {
        this.$mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./src/sharebase/domain/sharebase-dialog.ts